<template>
  <div class="transactions pane">
    <h3>Transactions</h3>

    <div class="filters">
      <label>
        <span>Show</span>
        <select v-model="filter">
          <option value="all">All</option>
          <option value="debit">Debits</option>
          <option value="credit">Credits</option>
          <option value="manual">Manual Adjustments</option>
        </select>
      </label>
      <label>
        <span>Sort by</span>
        <select v-model="sortBy">
          <option value="createdDate">Date</option>
          <option value="amount">Amount</option>
        </select>
      </label>
      <label>
        <select v-model.number="sortDir">
          <option value="-1">Descending</option>
          <option value="1">Ascending</option>
        </select>
      </label>
    </div>

    <table>
      <thead>
        <tr>
          <th>ID</th>
          <th>Amount</th>
          <th>Type</th>
          <th>Date</th>
          <th>Note</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="transaction of filteredTrans" :key="transaction.id">
          <td class="id">{{ transaction.id }}</td>
          <td
            class="amount"
            :class="{ p: transaction.amount > 0, n: transaction.amount < 0 }">
            {{ Math.abs(transaction.amount).toFixed(2) }}
          </td>
          <td class="type">{{ transaction.type }}</td>
          <td class="date" :title="transaction.created.toDate() | moment('MM/DD/YY H:mma [(UTC ]Z)')">{{ transaction.created.toDate() | moment('from') }}</td>
          <td class="note">{{ transaction.note }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>


export default {
  name: 'Transactions',
  props: ['transactions'],

  data () {
    return {
      filter: 'all',
      sortBy: 'createdDate',
      sortDir: -1
    }
  },

  computed: {
    filteredTrans () {
      let { sortBy, sortDir } = this
      const trans = this.transactions
        .slice(0)
        .map((trx) => {
          return {
            ...trx,
            id: trx.id,
            createdDate: trx.created.toDate(),
            amountAbs: Math.abs(trx.amount)
          }
        })
        .filter((trx) => {
          if (this.filter === 'credit') {
            return trx.amount > 0
          } else if (this.filter === 'debit') {
            return trx.amount < 0
          } else if (this.filter === 'manual') {
            return trx.type === 'manual'
          }
          return true
        })

      // This is weird: if we're filtering specifically credits/debits, then the
      // sort direction should probably apply to the absolute trx amount.
      // Sorting transactions by amount descending we expect to see the biggest
      // numbers on top, but debits are technically negative
      if (this.filter !== 'all' && sortBy === 'amount') {
        sortBy = 'amountAbs'
      }
      return this.sort(trans, sortBy, sortDir)
    },
    transDesc () {
      const trx = this.transactions.slice(0)
      trx.sort((a, b) => Math.sign(b.created.toDate() - a.created.toDate()))
      return trx
    }
  },

  methods: {
    sort (items, field, direction = -1) {
      const copy = items.slice(0)
      copy.sort((a, b) => Math.sign(a[field] - b[field]) * direction)
      return copy
    }
  }
}
</script>

<style scoped>

.filters label {
  padding: 0 0.25em;
}
.filters select {
  border: 0;
  background: transparent;
  font: inherit;
  text-align: right;
  color: green;
}
th {
  text-align: left;
}
th,
td {
  padding: 0 0.25em;
}

.transactions table {
  border-collapse: collapse;
}
.transactions table th,
.transactions table td {
  padding: 0 1em;
}
th {
  text-align: left;
}
td.id {
  font-size: smaller;
  font-family: monospace;
}
td.amount { text-align: right; }
td.amount::before { float: left; }
td.amount.p { color: green; }
td.amount.p::before { content: '+'; }
td.amount.n { color: firebrick; }
td.amount.n::before { content: '-'; }
</style>
